import { Row, Space } from 'antd';

import { useUserRole } from 'hooks';

import { CopyProduct } from './CopyProduct';
import { DeleteProduct } from './DeleteProduct';

export const ProductActions = () => {
  const { isAdmin } = useUserRole();

  if (!isAdmin) {
    return null;
  }

  return (
    <Row justify='end'>
      <Space size={10}>
        <CopyProduct />

        <DeleteProduct />
      </Space>
    </Row>
  );
};
